import React, {
  useState,
} from 'react';

import {
  TableTabContainer,
} from '../styles';

import TracksTable from './components/TracksTable';
import TrackEditor from './components/TrackEditor';
import {
  isEditAction,
  isEditorView,
} from './utils';

const Tracks = () => {
  const [selectedTrack, setSelectedTrack] = useState(null);
  const [actionPerformed, setActionPerformed] = useState(null);

  const handleActionClick = (track, action) => {
    setSelectedTrack(track);
    setActionPerformed(action);
  };

  return (
    <TableTabContainer>
      {isEditorView(actionPerformed, selectedTrack)
        ? (
          <TrackEditor
            trackDoc={selectedTrack}
            isEditView={isEditAction(actionPerformed, selectedTrack)}
            onClose={() => handleActionClick(null, null)}
          />
        )
        : <TracksTable handleActionClick={handleActionClick} />}
    </TableTabContainer>
  );
};

export default Tracks;
